module.exports = __webpack_public_path__ + "img/1_007.cff731ea.jpg";